export default '/api'